import React, { useState, useEffect, useLayoutEffect } from 'react';
import Search from '../../components/Search.jsx';
import Table from '../../components/Table.jsx';
import useFetch from '../../hooks/useFetch.js';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { expertCaseListTable, patientCaseListTable } from '../../utils/tables-config.jsx';

function CaseList() {
  const { role } = useSelector((state) => state.mainFun.user);

  const [caseListData, setCaseListData] = useState([]);
  const [searchedData, setSearchedData] = useState();
  const [tHead, setTHead] = useState();
  const { data, fetchData } = useFetch({ url: 'case/list', loading: true, body: {} });
  const { t } = useTranslation();

  const downloadInvoice = async (caseId) => {
  try {
    const response = await fetchData({
      url: `case/${caseId}/invoice/download`,
      loading: true,
      responseType: 'blob',

      // Only this request asks useFetch to return headers.
      includeResponseHeaders: true,
    });

    if (!(response?.result instanceof Blob)) {
      console.error(
        'Invoice response is not a Blob:',
        response
      );
      return;
    }

    const contentDisposition =
      response?.headers?.['content-disposition'];

    console.log(
      'Content-Disposition:',
      contentDisposition
    );

    let filename = `invoice-${caseId}.pdf`;

    if (contentDisposition) {
      // Your Odoo response uses this format:
      // filename*=UTF-8''Patient%20Test%20-%20plo-2025-00044.pdf
      const utf8Match = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      );

      const normalMatch = contentDisposition.match(
        /filename="?([^";]+)"?/i
      );

      if (utf8Match?.[1]) {
        try {
          filename = decodeURIComponent(
            utf8Match[1]
              .trim()
              .replace(/^["']|["']$/g, '')
          );
        } catch {
          filename = utf8Match[1]
            .trim()
            .replace(/^["']|["']$/g, '');
        }
      } else if (normalMatch?.[1]) {
        filename = normalMatch[1].trim();
      }
    }

    console.log('Downloading as:', filename);

    const url = URL.createObjectURL(response.result);

    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    link.remove();

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 1000);
  } catch (error) {
    console.error(
      `Error downloading invoice for case ${caseId}:`,
      error
    );
  }
};

  useLayoutEffect(() => {
    if (role == 'patient') {
      setTHead(t('case_list.patient_head', { returnObjects: true }));
    } else {
      setTHead(t('case_list.expert_head', { returnObjects: true }));
    }
  }, []);

  useEffect(() => {
    if (data?.result?.cases) {
      const newList = [];
      if (role == 'patient') {

        data.result.cases = data.result.cases.sort((a, b) => b.id - a.id);
        data.result.requests_list?.map((e) => {
          newList.push(
            patientCaseListTable(
              {
                name: e.request_number,
                state: 'draft',
                patient_name: e.partner_name,
                id: e.partner_id?.[0]
              },
              t,
              true
            )
          );
        });
        data.result.cases.map((e) => {
          let state = e.state.toLowerCase();
          let caseInProgress = false;

          if (state === 'draft') {
            caseInProgress = true;
          }

          ['data collection'].includes(state) && e.payment_status == 'pending'
            ? (e.state = t('status.pending_payment_confirmation'))
            : ['data collection'].includes(state) && e.payment_status == 'paid'
            ? (e.state = t('status.confirmed_payment'))
            : ['assigned', 'under review'].includes(state)
            ? (e.state = t('status.under_case_manager_review'))
            : ['sent to expert', 'accepted'].includes(state)
            ? (e.state = t('status.expert_review'))
            : (e.state = t(`status.${state.replaceAll(' ', '_')}`));
          newList.push(patientCaseListTable(e, t, caseInProgress, downloadInvoice));
        });
      } else if (role == 'expert') {
        data.result.cases.map((e) => {
          !e.patient_first_name && (e.patient_first_name = e.patient_name?.split(' ')[0]);
          !e.patient_last_name && (e.patient_last_name = e.patient_name?.split(' ')[1]);
          e.state = t(`status.${e.state.toLowerCase().replaceAll(' ', '_')}`);
          newList.push(expertCaseListTable(e, t, downloadInvoice));
        });
      }
      setCaseListData(newList);
    }
  }, [data]);

  return (
    <div>
      <Search setSearchedData={setSearchedData} caseListData={caseListData} />
      {caseListData.length > 0 ? (
        <div className="mb-4">
          <Table tHead={tHead} data={searchedData ? searchedData : caseListData} caseView={true} />
        </div>
      ) : (
        <p className="text-center mt-5">{t('case_list.no_cases')}</p>
      )}
    </div>
  );
}
export default CaseList;